module.exports = __webpack_public_path__ + "img/hands-holding-dollar.f57f1499.svg";